import { render, staticRenderFns } from "./UploadTaxReturnModal.vue?vue&type=template&id=7a5b1434&"
import script from "./UploadTaxReturnModal.vue?vue&type=script&lang=ts&"
export * from "./UploadTaxReturnModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports